import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import "./passwordCreated.scss";
const PasswordCreated = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  return (
    <div
      className="d-flex justify-content-center align-items-center flex-column w-100"
      style={{ height: "100vh" }}
    >
      <img src={"/assets/icons/successicon.png"} style={{ width: "200px" }} />
      <h4 className="fw-bold">{t("password-created")}</h4>
      <p>{t("password-created-success")}</p>
      <button
        className="loginRedirectButton"
        type="submit"
        onClick={() => (window.location = `${state?.redirectUrl || "/"}`)}
      >
        Zum Login
      </button>
    </div>
  );
};

export default PasswordCreated;
